export default __webpack_public_path__ + "static/3-792493cfda93d55ea7e76e874f27263d.jpeg";